import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import TransactionContext from '@/product/context/transaction/transactionContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { useFormik } from 'formik'
import ReportContext from '@/product/context/report/reportContext'
import { Button } from '@mui/material'
import moment from 'moment'
import { handleRedirectInternal } from '../../custom/common/components'
import { useHistory } from 'react-router-dom'
import SellerPayoutContext from '@/product/context/sellerPayout/sellerPayoutContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'
import AlertContext from '@/product/context/alert/alertContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { mapData } from '@/product/common/components'
import * as Yup from 'yup'

const ManualTransfer = (props) => {
    const reportContext = useContext(ReportContext)
    const sellerPayoutContext = useContext(SellerPayoutContext)
    const customCommonContext = useContext(CustomCommonContext)
    const { allConfigurationVariables } = customCommonContext

    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext

    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [isLoading, setIsLoading] = useState(true)
    const [selectedFilter, setSelectedFilter] = useState('all') // 'all', 'paid', 'due'
    const {
        getAllSellerPayoutLogsZb: getAllSellerPayoutLogs,
        all_payment_zb: all_payment,
        sellerTransfer,
        updateInvoiceSellerStatus,
        updateSellerPayoutLogs,
        responseStatus: responseStatusInvoice,
        clearResponse: clearResponseInvoice,
    } = sellerPayoutContext

    let action = props.match.params.action
    const { getAllExportDownload } = reportContext

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                type: {
                    value: '',
                    type: 'in',
                    field: 'zpl.type',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'zpl.invoice_id',
                },
                fromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'zpl.transfer_completed_at',
                },
                todate: {
                    value: '',
                    isEnd: true,
                    type: 'datesmallerequal',
                    field: 'zpl.transfer_completed_at',
                },
                project_id: {
                    value: '',
                    type: 'like',
                    field: 'b.project_id',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)

            // if (submitValue.filters.fromdate.value) {
            //     submitValue.filters.fromdate.value = moment(
            //         submitValue.filters.fromdate.value,
            //         'MM-DD-YYYY'
            //     ).format()
            // }
            // if (submitValue.filters.todate.value) {
            //     submitValue.filters.todate.value = moment(
            //         submitValue.filters.todate.value,
            //         'MM-DD-YYYY'
            //     ).format()
            // }
            getAllSellerPayoutLogs(values)
        },
    })
    const history = useHistory()
    // const onClickEdit = (id, secondaryID, type) => {
    //     handleRedirectInternal(
    //         history,
    //         `invoice/view/paid/${id}/${secondaryID}`
    //     )
    // }
    const onClickViewNew = (id, sid, type) => {
        window.open(
            `${location.origin}/invoice/view/paid/${id}/${sid}`,
            '_blank',
            'noopener,noreferrer'
        )
        // toggleFullScreenPopup(true, type, id, sid)
    }

    useEffect(() => {
        if (all_payment) {
            setTableBody(all_payment.records.length ? all_payment.records : [])
        }
        setIsLoading(false)
    }, [all_payment])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        // formik.values.filters.type.value = action
        formik.values.page = 1
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''
        formik.values.api_status = ''
        setSelectedFilter('all')

        formik.handleSubmit()
        /* return () => {
            setTableBody([])
        }*/
    }, [action])

    useEffect(() => {
        if (responseStatusInvoice) {
            if (
                responseStatusInvoice.from === 'sellerTransfer' &&
                responseStatusInvoice.status === 'success'
            ) {
                setChangeStatus(false)
                formik.handleSubmit()
            }

            if (
                responseStatusInvoice.from === 'updateInvoiceSellerStatus' &&
                responseStatusInvoice.status === 'success'
            ) {
                setChangeStatus(false)
                formik.handleSubmit()
            }

            if (
                responseStatusInvoice.from === 'updateSellerPayoutLogs' &&
                responseStatusInvoice.status === 'success'
            ) {
                setChangeStatus(false)
                formik.handleSubmit()
            }

            setIsLoading(false)
        }
    }, [responseStatusInvoice])

    const validationArray = Yup.object({
        action: Yup.string(),
        edit_amount: Yup.number().when(['action', 'edit_total_amount'], {
            is: (action, edit_total_amount) => action === 'edit_amount',
            then: (schema) =>
                schema
                    .min(0, `Minimum has to be 0 `)
                    .test(
                        'not-exceed-total',
                        'Transfer amount cannot exceed total amount',
                        function (value) {
                            const { edit_total_amount } = this.parent
                            if (
                                value !== undefined &&
                                edit_total_amount !== undefined &&
                                edit_total_amount !== ''
                            ) {
                                return value <= edit_total_amount
                            }
                            return true
                        }
                    )
                    .required('Enter Transfer Amount'),
        }),
    })

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            id: '',
            ids: '',
            seller_id: '',
            amount: '',
            seller_account_id: '',
            edit_amount: '',
            edit_total_amount: '',
            project_id: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (values.action === 'edit') {
                setIsLoading(true)
                sellerTransfer({
                    id: values.id,
                    seller_id: values.secondaryID,
                    amount: values.amount,
                    seller_account_id: values.seller_account_id,
                })
            } else if (values.action === 'retry') {
                setIsLoading(true)
                updateInvoiceSellerStatus({
                    seller_payout_status: '0',
                    id: values.id,
                    project_id: values.project_id,
                })
            } else if (values.action === 'edit_amount') {
                setIsLoading(true)
                console.log('TTTTT edit_amount', values)
                updateSellerPayoutLogs({
                    id: values.id,
                    amount: values.edit_amount,
                })
            } else if (
                values.action === 'cancel' ||
                values.action === 'mark_as_paid'
            ) {
                setIsLoading(true)
                console.log('TTTTT Cancel', values)
                if (values.action === 'mark_as_paid' && values.ids) {
                    updateSellerPayoutLogs({
                        ids: values.ids,
                        status: 'Completed',
                    })
                } else {
                    updateSellerPayoutLogs({
                        id: values.id,
                        status: 'Canceled',
                    })
                }
            }
        },
    })

    const onSelectMultiProducts = (id, secondaryID, type) => {
        formikSelection.setTouched({}, false)
        if (type === 'mark_as_paid' || secondaryID === 'mark_as_paid') {
            formikSelection.setFieldValue('action', type || secondaryID)
            formikSelection.setFieldValue('ids', id)
            setChangeStatus(true)
        } else if (type === 'cancel') {
            formikSelection.setFieldValue('action', type)
            formikSelection.setFieldValue('id', id)

            setChangeStatus(true)
        } else if (type === 'edit_amount') {
            console.log('id, secondaryID, type', id, secondaryID, type)
            formikSelection.setFieldValue('action', type)
            formikSelection.setFieldValue('id', id)
            formikSelection.setFieldValue('edit_total_amount', secondaryID)
            formikSelection.setFieldValue('edit_amount', secondaryID)

            setChangeStatus(true)
        } else if (type === 'edit') {
            console.log(id, type, secondaryID, 'coming action')

            let filterData = tableBody.filter((data) => data.id == id)
            console.log('filterData NEEE', filterData)
            if (filterData.length) {
                if (filterData[0].status === 'Waiting_For_Transfer') {
                    if (filterData[0].picked_up_date) {
                        let returnDueDays =
                            allConfigurationVariables?.return_due_days
                                ? parseInt(
                                      allConfigurationVariables.return_due_days,
                                      10
                                  ) + 2
                                : 7 + 2

                        let deadlineWithGrace = new Date(
                            filterData[0].picked_up_date
                        )
                        deadlineWithGrace.setDate(
                            deadlineWithGrace.getDate() + returnDueDays
                        )
                        console.log(
                            'allConfigurationVariables returnDueDays',
                            returnDueDays,
                            filterData[0].picked_up_date
                        )

                        const now = new Date()
                        console.log('deadlineWithGrace', now, deadlineWithGrace)
                        if (now > deadlineWithGrace) {
                            formikSelection.setFieldValue('action', type)
                            formikSelection.setFieldValue('id', id)
                            formikSelection.setFieldValue(
                                'seller_id',
                                secondaryID
                            )
                            formikSelection.setFieldValue(
                                'amount',
                                filterData[0].amount
                            )
                            formikSelection.setFieldValue(
                                'seller_account_id',
                                filterData[0].users_seller_account_id
                            )

                            setChangeStatus(true)
                        } else {
                            setAlert(
                                'Pickup Deadline + 2 Days not reached',
                                'error'
                            )
                        }
                    } else {
                        setAlert('Item not picked up', 'error')
                    }
                } else {
                    setAlert('Status is not in pending', 'error')
                }
            }
        } else if (type === 'retry') {
            formikSelection.setFieldValue('action', type)
            formikSelection.setFieldValue('id', id)
            formikSelection.setFieldValue('project_id', secondaryID)
            setChangeStatus(true)
        }
    }

    const getMultipleAutoAction = () => {
        let actionPush = [
            {
                buttonType: 'replay',
                clickType: 'retry',
                onclick: onSelectMultiProducts,
                clickID: 'buynow_id',
                condition: true,
                conditionValue: {
                    formula: {
                        isString: true,
                        key1: 'api_status',
                        key2: 'error',
                        notation: '===',
                    },
                },
                secondaryClickID: 'project_id',
                tooltipTitle: 'Retry transfer',
            },
            {
                buttonType: 'cancel',
                clickType: 'cancel',
                condition: true,
                conditionValue: {
                    formula: {
                        isString: true,
                        key1: 'status',
                        key2: 'Waiting_For_Transfer',
                        notation: '===',
                    },
                },
                onclick: onSelectMultiProducts,
                clickID: 'id',
                secondaryClickID: 'seller_id',
                tooltipTitle: 'Cancel Payment',
            },
            {
                buttonType: 'edit',
                clickType: 'edit_amount',
                condition: true,
                conditionValue: {
                    formula: {
                        isString: true,
                        key1: 'status',
                        key2: 'Waiting_For_Transfer',
                        notation: '===',
                    },
                },
                onclick: onSelectMultiProducts,
                clickID: 'id',
                secondaryClickID: 'amount',
                tooltipTitle: 'Edit payment',
            },
        ]
        return actionPush
    }

    const getMultipleAction = () => {
        let actionPush = [
            // {
            //     buttonType: 'monetization_on',
            //     clickType: 'edit',
            //     condition: true,
            //     conditionValue: {
            //         formula: {
            //             isString: true,
            //             key1: 'status',
            //             key2: 'Waiting_For_Transfer',
            //             notation: '===',
            //         },
            //     },
            //     onclick: onSelectMultiProducts,
            //     clickID: 'id',
            //     secondaryClickID: 'seller_id',
            //     tooltipTitle: 'Make payment',
            // },
            {
                buttonType: 'cancel',
                clickType: 'cancel',
                condition: true,
                conditionValue: {
                    formula: {
                        isString: true,
                        key1: 'status',
                        key2: 'Waiting_For_Transfer',
                        notation: '===',
                    },
                },
                onclick: onSelectMultiProducts,
                clickID: 'id',
                secondaryClickID: 'seller_id',
                tooltipTitle: 'Cancel Payment',
            },
            {
                buttonType: 'edit',
                clickType: 'edit_amount',
                condition: true,
                conditionValue: {
                    formula: {
                        isString: true,
                        key1: 'status',
                        key2: 'Waiting_For_Transfer',
                        notation: '===',
                    },
                },
                onclick: onSelectMultiProducts,
                clickID: 'id',
                secondaryClickID: 'amount',
                tooltipTitle: 'Edit payment',
            },
        ]
        return actionPush
    }

    const tableValues = [
        {
            field: 'invoice_id',
            type: 'hyperlink',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Invoice ID',
            click: true,
            onclick: onClickViewNew,
            clickID: 'invoice_id',
            secondaryClickID: 'buyer_id',
            filterable: true,
            filterField: 'zpl.invoice_id',
        },
        {
            field: 'project_id',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Product ID',
        },
        {
            field: 'total_paid',
            type: 'price',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Total Amount',
        },
        {
            field: 'per_total',
            type: 'price',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Sub Total',
        },
        {
            field: 'prdt_total_amount',
            type: 'price',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Card Paid',
        },
        {
            field: 'seller_amount',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Seller Payout Amount',
        },
        {
            field: 'total_trans_fee',
            type: 'price',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Total Trans Fees',
        },
        {
            field: 'lsi_trans_fee',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'LSI Fee',
        },
        {
            field: 'zb_fee',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'ZB Fee',
        },
        {
            field: 'tax',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Tax',
        },
        {
            field: 'additional_trans_fee',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Additional Trans Fee',
        },

        {
            field: 'amount',
            type: 'price',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Transfer Amount',
        },
        {
            field: 'type',
            type: 'capitalize',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Type',
        },
    ]

    if (action === 'manual') {
        tableValues.push({
            field: 'sub_type',
            type: 'capitalize',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Sub Type',
        })
    }

    let extraColumns = [
        // {
        //     field: 'as_employees_emp_firstname',
        //     type: '',
        //     sort: false,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Seller First Name',
        //     filterable: true,
        //     filterField: 'e.emp_firstname',
        // },
        // {
        //     field: 'as_employees_emp_lastname',
        //     type: '',
        //     sort: false,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Seller Last Name',
        //     filterable: true,
        //     filterField: 'e.emp_lastname',
        // },
        // {
        //     field: 'as_employees_emp_email',
        //     type: '',
        //     sort: false,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Seller Email',
        //     filterable: true,
        //     filterField: 'e.emp_email',
        // },
        {
            field: 'created_at',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Created Date',
        },

        {
            field: 'status',
            type: 'capitalize',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'api_status',
            type: 'tooltip',
            tooltipType: 'field',
            tooltipTitle: 'errMsg',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'API Status',
        },
        // {
        //     field: 'transfer_completed_at',
        //     type: 'date',
        //     sort: true,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Transferred Date',
        // },
    ]

    tableValues.push(...extraColumns)

    if (action === 'auto') {
        tableValues.push({
            field: 'api_status',
            type: 'tooltip',
            tooltipType: 'field',
            tooltipTitle: 'errMsg',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'API Status',
        })
    }

    // if (action === 'manual') {
    //     tableValues.push({
    //         field: 'action',
    //         type: 'button',
    //         sort: false,
    //         firstChild: false,
    //         clickID: 'common_invoice',
    //         disablePadding: false,
    //         label: 'Action',
    //         isMultiple: getMultipleAction(),
    //     })
    // }

    // if (action === 'auto') {
    //     tableValues.push({
    //         field: 'action',
    //         type: 'button',
    //         sort: false,
    //         firstChild: false,
    //         clickID: 'common_invoice',
    //         disablePadding: false,
    //         label: 'Action',
    //         isMultiple: getMultipleAutoAction(),
    //     })
    // }

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Invoice Number',
                placeholder: 'Enter invoice number',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            {
                label: 'Product ID',
                placeholder: 'Enter Product ID',
                class: 'col-md-4 col-sm-6 col-12',
                type: '',
                name: 'project_id',
                filter: true,
            },
            // {
            //     label: 'Transferred  From Date',
            //     placeholder: 'Date Ending from',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'date',
            //     name: 'fromdate',
            //     filter: true,
            // },
            // {
            //     label: 'Transferred To Date',
            //     placeholder: 'Date Ending To',
            //     class: 'col-md-4 col-sm-6 col-12',
            //     type: 'date',
            //     name: 'todate',
            //     filter: true,
            // },
        ],
    }

    const resetForm = () => {
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''
        formik.values.api_status = ''
        setSelectedFilter('all')
        formik.handleSubmit()
    }

    const handleFilterClick = (filterType) => {
        setSelectedFilter(filterType)
        setIsLoading(true)

        const currentValues = { ...formik.values }

        if (filterType === 'all') {
            currentValues.api_status = ''
        } else if (filterType === 'paid') {
            currentValues.api_status = 'success'
        } else if (filterType === 'due') {
            currentValues.api_status = 'error'
        }

        if (currentValues.filters.api_status) {
            delete currentValues.filters.api_status
        }

        getAllSellerPayoutLogs(currentValues)
    }

    const tableActions = []

    if (action === 'manual') {
        tableActions.push({
            label: 'Mark as Paid',
            clickID: 'id',
            secondaryClickID: 'id',
            type: 'mark_as_paid',
            buttonType: 'mark_as_paid',
            icon: <span className="material-icons">payment</span>,
            onclick: onSelectMultiProducts,
        })
    }

    const transferAmount = [
        {
            label: 'Enter Transfer Amount',
            name: 'edit_amount',
            type: 'number',
            placeholder: ``,
            class: 'col-12',
            size: 'small',
            autoFocus: false,
            formik: formikSelection,
        },
    ]

    return (
        <Layout>
            <div className="dashboard invoice">
                <CustomSearch
                    searchInfo={searchInfo}
                    formik={formik}
                    advFilters={true}
                    resetForm={resetForm}
                />

                {/* Summary Boxes */}
                <div className="summary-boxes" style={{ marginBottom: '20px' }}>
                    <div style={{ marginBottom: '15px' }}>
                        <div
                            style={{
                                display: 'flex',
                                gap: '15px',
                                flexWrap: 'wrap',
                            }}
                        >
                            <div
                                className={`summary-box ${
                                    selectedFilter === 'paid' ? 'active' : ''
                                }`}
                                onClick={() => handleFilterClick('paid')}
                                style={{
                                    padding: '15px 20px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    backgroundColor:
                                        selectedFilter === 'paid'
                                            ? '#f0f0f0'
                                            : '#fff',
                                    borderColor:
                                        selectedFilter === 'paid'
                                            ? '#9c27b0'
                                            : '#e0e0e0',
                                    minWidth: '150px',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        marginBottom: '5px',
                                    }}
                                >
                                    Total Amount
                                </div>
                                <div
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#4caf50',
                                    }}
                                >
                                    $
                                    {all_payment?.summary?.paidAmount
                                        ? all_payment.summary.paidAmount.toFixed(
                                              2
                                          )
                                        : '0.00'}
                                </div>
                            </div>

                            <div
                                className={`summary-box ${
                                    selectedFilter === 'paid' ? 'active' : ''
                                }`}
                                onClick={() => handleFilterClick('paid')}
                                style={{
                                    padding: '15px 20px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    backgroundColor:
                                        selectedFilter === 'paid'
                                            ? '#f0f0f0'
                                            : '#fff',
                                    borderColor:
                                        selectedFilter === 'paid'
                                            ? '#9c27b0'
                                            : '#e0e0e0',
                                    minWidth: '150px',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        marginBottom: '5px',
                                    }}
                                >
                                    ZB Fee
                                </div>
                                <div
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#4caf50',
                                    }}
                                >
                                    $
                                    {all_payment?.summary?.paidZbFee
                                        ? all_payment.summary.paidZbFee.toFixed(
                                              2
                                          )
                                        : '0.00'}
                                </div>
                            </div>
                            <div
                                className={`summary-box ${
                                    selectedFilter === 'paid' ? 'active' : ''
                                }`}
                                onClick={() => handleFilterClick('paid')}
                                style={{
                                    padding: '15px 20px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    backgroundColor:
                                        selectedFilter === 'paid'
                                            ? '#f0f0f0'
                                            : '#fff',
                                    borderColor:
                                        selectedFilter === 'paid'
                                            ? '#9c27b0'
                                            : '#e0e0e0',
                                    minWidth: '150px',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        marginBottom: '5px',
                                    }}
                                >
                                    Tax
                                </div>
                                <div
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#4caf50',
                                    }}
                                >
                                    $
                                    {all_payment?.summary?.paidTax
                                        ? all_payment.summary.paidTax.toFixed(2)
                                        : '0.00'}
                                </div>
                            </div>
                            <div
                                className={`summary-box ${
                                    selectedFilter === 'paid' ? 'active' : ''
                                }`}
                                onClick={() => handleFilterClick('paid')}
                                style={{
                                    padding: '15px 20px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    backgroundColor:
                                        selectedFilter === 'paid'
                                            ? '#f0f0f0'
                                            : '#fff',
                                    borderColor:
                                        selectedFilter === 'paid'
                                            ? '#9c27b0'
                                            : '#e0e0e0',
                                    minWidth: '150px',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        marginBottom: '5px',
                                    }}
                                >
                                    Transaction Fee
                                </div>
                                <div
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#4caf50',
                                    }}
                                >
                                    $
                                    {all_payment?.summary?.paidTransFee
                                        ? all_payment.summary.paidTransFee.toFixed(
                                              2
                                          )
                                        : '0.00'}
                                </div>
                            </div>

                            <div
                                className={`summary-box ${
                                    selectedFilter === 'due' ? 'active' : ''
                                }`}
                                onClick={() => handleFilterClick('due')}
                                style={{
                                    padding: '15px 20px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    backgroundColor:
                                        selectedFilter === 'due'
                                            ? '#f0f0f0'
                                            : '#fff',
                                    borderColor:
                                        selectedFilter === 'due'
                                            ? '#9c27b0'
                                            : '#e0e0e0',
                                    minWidth: '150px',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        marginBottom: '5px',
                                    }}
                                >
                                    Total Amount
                                </div>
                                <div
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#f44336',
                                    }}
                                >
                                    $
                                    {all_payment?.summary?.dueAmount
                                        ? all_payment.summary.dueAmount.toFixed(
                                              2
                                          )
                                        : '0.00'}
                                </div>
                            </div>

                            <div
                                className={`summary-box ${
                                    selectedFilter === 'due' ? 'active' : ''
                                }`}
                                onClick={() => handleFilterClick('due')}
                                style={{
                                    padding: '15px 20px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    backgroundColor:
                                        selectedFilter === 'due'
                                            ? '#f0f0f0'
                                            : '#fff',
                                    borderColor:
                                        selectedFilter === 'due'
                                            ? '#9c27b0'
                                            : '#e0e0e0',
                                    minWidth: '150px',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        marginBottom: '5px',
                                    }}
                                >
                                    ZB Fee
                                </div>
                                <div
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#f44336',
                                    }}
                                >
                                    $
                                    {all_payment?.summary?.dueZbFee
                                        ? all_payment.summary.dueZbFee.toFixed(
                                              2
                                          )
                                        : '0.00'}
                                </div>
                            </div>
                            <div
                                className={`summary-box ${
                                    selectedFilter === 'due' ? 'active' : ''
                                }`}
                                onClick={() => handleFilterClick('due')}
                                style={{
                                    padding: '15px 20px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    backgroundColor:
                                        selectedFilter === 'due'
                                            ? '#f0f0f0'
                                            : '#fff',
                                    borderColor:
                                        selectedFilter === 'due'
                                            ? '#9c27b0'
                                            : '#e0e0e0',
                                    minWidth: '150px',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        marginBottom: '5px',
                                    }}
                                >
                                    Tax
                                </div>
                                <div
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#f44336',
                                    }}
                                >
                                    $
                                    {all_payment?.summary?.dueTax
                                        ? all_payment.summary.dueTax.toFixed(2)
                                        : '0.00'}
                                </div>
                            </div>
                            <div
                                className={`summary-box ${
                                    selectedFilter === 'due' ? 'active' : ''
                                }`}
                                onClick={() => handleFilterClick('due')}
                                style={{
                                    padding: '15px 20px',
                                    border: '2px solid #e0e0e0',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    backgroundColor:
                                        selectedFilter === 'due'
                                            ? '#f0f0f0'
                                            : '#fff',
                                    borderColor:
                                        selectedFilter === 'due'
                                            ? '#9c27b0'
                                            : '#e0e0e0',
                                    minWidth: '150px',
                                    textAlign: 'center',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: '14px',
                                        color: '#666',
                                        marginBottom: '5px',
                                    }}
                                >
                                    Transaction Fee
                                </div>
                                <div
                                    style={{
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        color: '#f44336',
                                    }}
                                >
                                    $
                                    {all_payment?.summary?.dueTransFee
                                        ? all_payment.summary.dueTransFee.toFixed(
                                              2
                                          )
                                        : '0.00'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <Button
                    id="transaction_report"
                    onClick={() =>
                        getAllExportDownload({
                            action: 'export',
                            order: 'asc',
                            orderby: '',
                            search: 'all',
                            report: `transaction_list`,
                        })
                    }
                >
                    <span className="material-icons">get_app</span>Export All
                    Data
                </Button> */}
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_payment}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllSellerPayoutLogs}
                />

                <CustomDialog
                    title={
                        formikSelection.values.action === 'edit_amount'
                            ? 'Edit Amount'
                            : formikSelection.values.action === 'retry'
                            ? 'Retry Transfer'
                            : formikSelection.values.action === 'cancel'
                            ? 'Cancel Transfer'
                            : 'Change Transfer Status'
                    }
                    open={changeStatus}
                    function={changeChangeStatus}
                >
                    <h5>
                        {formikSelection.values.action === 'edit_amount'
                            ? 'Are you sure you want to change edit the amount'
                            : formikSelection.values.action === 'retry'
                            ? 'Are you sure you want to retry the transfer'
                            : formikSelection.values.action === 'cancel'
                            ? 'Are you sure you want to cancel the transfer'
                            : 'Are you sure you want to change the status'}
                    </h5>
                    <div className="row">
                        {formikSelection.values.action === 'edit_amount' ? (
                            <> {mapData(transferAmount)} </>
                        ) : null}
                    </div>

                    <div className="actionWrapper">
                        <Button onClick={() => changeChangeStatus()}>
                            Cancel
                        </Button>
                        <form
                            onSubmit={formikSelection.handleSubmit}
                            autoComplete="nofill"
                        >
                            <PrimaryButton type="submit" label="Confirm" />
                        </form>
                    </div>
                </CustomDialog>
            </div>
        </Layout>
    )
}

export default ManualTransfer
